import { createLogger } from 'aven_shared/src/utils/otel/logger'
import { inspect } from 'aven_shared/src/utils/logger'
import { appSessionStorage, localStorageKey } from './storage'

const getMetadata = (): Record<string, string> => {
    const metadata: Record<string, string> = {}
    const sessionId = appSessionStorage.getItem(localStorageKey.sessionId)
    if (sessionId) {
        metadata.sessionId = sessionId
    }
    const sessionRecordingUrl = appSessionStorage.getItem(localStorageKey.sessionRecordingUrl)
    if (sessionRecordingUrl) {
        metadata.sessionRecordingUrl = sessionRecordingUrl
    }

    if (window.nativeAppVersion) {
        metadata.nativeAppVersion = window.nativeAppVersion
    }

    if (window.installId) {
        metadata.nativeAppInstallId = window.installId
    }
    return metadata
}

const log = createLogger({
    avenProject: 'advisor',
    logProcessorBaseUrl: process.env.VUE_APP_LOGGER_BASE_URL ? process.env.VUE_APP_LOGGER_BASE_URL.replace(/\/logs\/?$/, '/client-logs') : undefined,
    clientSideLogsEnabled: process.env.VUE_APP_CLIENT_SIDE_LOGS_ENABLED === 'yes',
    getContext: getMetadata,
})

window.logger = log

export { log, inspect }
